import { Button, Card, Form, Input, InputNumber, Modal, Table, Upload, message } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import { getBaseUrl } from '../../../../config/base-url';
import { route } from '../../../requests/routes';
import { useSellerAdjust, useSellerPayment, useSellerPaymentTransections, useSellerTotalRemainingAmount } from '../../../requests/seller';

import { IoSyncOutline } from "react-icons/io5";
import history from '../../../helper/history';

const SellerTransections = () => {

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [isModalOpen, setIsModalOpen] = useState(false);

  function modalToggle() {
    setIsModalOpen(!isModalOpen);
  }

  const { id } = useParams();
  const { data: transectionData, isLoading } = useSellerPaymentTransections({ page, pageSize, id });
  const { mutate, isLoading:paymentLoading } = useSellerPayment();

  const { mutate:adjustTrnxAction, isLoading: adjustBalanceLoading }  = useSellerAdjust(id);
  const { data: sellerTotalRevenue } = useSellerTotalRemainingAmount({ id: id });

  const queryClient = useQueryClient();

  // Payment
  const [payment, setPayment] = useState({
    amount: 0,
    note: "",
    files: ""
  });



  function invalidateQueries() {
    // invalidate transection data
    queryClient.invalidateQueries([route.SELLER_TRANSECTION_LIST, id, page, pageSize]);
    queryClient.invalidateQueries([route.SELLER_TOTAL_CURRENT_BALANCE_AMOUNT, id]);
    queryClient.invalidateQueries([route.SELLER_TOTAL_PAID_AMOUNT, id]);
    queryClient.invalidateQueries([route.SELLER_TOTAL_REVENUE, id]);
    queryClient.invalidateQueries([route.SELLER_TOTAL_SALE_AMOUNT, id]);
  }
  
  
  function submitPayment(){

    // validation 
    // if(payment?.amount <= 0){
    //   message.error("Please enter amount");
    //   return;
    // }

    mutate({...payment, vendor_id: id }, {
      onSuccess: () => {
        message.success("Payment submitted");
        modalToggle();

        // reset data
        setPayment({
          amount: 0,
          note: "",
          files: ""
        });

        invalidateQueries();

      },
      onError: (error) => {
        message.error(error?.message ?? "Something went wrong");
      }
    });

  }

  console.log('work', sellerTotalRevenue);


  const columns = [
    {
      title: 'Date',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: createdAt => createdAt?  moment(createdAt).format('DD-MM-YYYY') :""
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: type => type === 'payment' ? 'Payment' : 'Order'
    },
    {
      title: 'Order ID',
      dataIndex: 'order_id',
      key: 'order_id',
      render: order_id => order_id===0 ? "":  order_id
    },
    {
      title: 'Order Amount',
      dataIndex: 'order_amount',
      key: 'order_amount',
      render: order_amount => order_amount===0 ? "":  order_amount
    },
    {
      title: 'Comission',
      dataIndex: 'order_amount',
      key: 'order_amount',
      render: (order_amount, row) => row?.type==="order-amount"? parseFloat((order_amount ?? 0) - (row?.amount ?? 0)).toFixed(2):""
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: 'Remarks',
      dataIndex: 'note',
      key: 'note',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Paid By',
      dataIndex: 'paid_by',
      key: 'paid_by',
    },
  ];

  return (
    <>
    <div style={{ minWidth:400, overflow:"auto" }}>
      <Card 
        key={`seller-transection-card-${id}`}
        title="Transections" 
        style={{ minHeight:200 }}
        extra={
          <div key={`seller-transectio-add-button`}>

            {!isLoading && transectionData?.transections?.length == 0 && 
            <Button loading={adjustBalanceLoading} onClick={() => adjustTrnxAction(id, {
              onSuccess: () => {
                invalidateQueries();
              },
              onError: (error) => {
                console.log(error);   
                message.error(error?.message ?? "Something went wrong");
              }

            })}>
              <IoSyncOutline />
            </Button>
             }

             <Button onClick={e => {
              const url = `${getBaseUrl()}/api/sellers/seller_transection_list_excell_download/${id}`; 
              window.open(url, '_blank');

             }}>
              Download Excel file
             </Button>
            
            <Button  onClick={modalToggle}>Make Payment</Button>
            <Button onClick={e => {
              history.back();
            }}>Back</Button>
          </div>
        }
        
        >
        <Table 
          size='small'
          dataSource={transectionData?.transections ?? []} 
          columns={columns} 
          loading={isLoading}
          pagination={{
            total: transectionData?.rowCount ?? 0,
            current: page,
            pageSize: pageSize,
            onChange: (page, pageSize) => {
              setPage(page);
              setPageSize(pageSize);
            }
          }}
        />
      </Card>

    </div>

      <Modal
        okText="Submit"
        centered 
        okButtonProps={{ loading: paymentLoading  }}
        title={`Make Payment - ( Current Balance : BDT ${parseFloat(sellerTotalRevenue?.data ?? 0).toFixed(2)} )`} open={isModalOpen} onOk={submitPayment} onCancel={modalToggle}>
          <Form layout='vertical' >
              <Form.Item label={`Paid amount : `}>
                <InputNumber 
                onFocus={e => e.target.select()}
                value={payment?.amount}
                onChange={e => {
                  setPayment(p => ({
                    ...p,
                    amount: e
                  }));
                }}
                
                type='number'  style={{ width:"100%" }} />
              </Form.Item>

              <Form.Item 
              label="(Payment Proof / Screenshots / Invoice) in JPG/JEPG/PNG format">
                <Upload
                  action={`${getBaseUrl()}/api/upload_product_image`}
                  name='product_image'
                  listType="picture"
                  onChange={e => {
                    console.log(e)
                    setPayment(p => ({
                      ...p,
                      files: e?.fileList.map(x => x?.response?.image).join(",")
                    }));
                  }}
                >
                  <Button>Upload</Button>
                </Upload>
              </Form.Item>
              <Form.Item label="Remarks">
                <Input.TextArea
                onChange={e => {
                  setPayment(p => ({
                    ...p,
                    note: e?.target?.value
                  }));
                }}
                value={payment?.note}
                placeholder='Remarks' />
              </Form.Item>
          </Form>
        
      </Modal>
    </>
  )
}

export default SellerTransections